// extracted by mini-css-extract-plugin
export var videoContainer = "_jz-0";
export var videoIframe = "_jz-3";
export var videoLink = "_jz-1";
export var videoOverlay = "_jz-4";
export var videoOverlayText = "_jz-5";
export var videoWrapper = "_jz-2";